import tools from 'assets/images/betslip/Tools.png';
import { t } from 'i18next';
import { FC } from 'react';
import './styles.scss';

interface Props {
	title: string;
	isAkoBet: boolean;
	numOfSlipsInBetslip: number;
	totalOdds: number;
	renderEmoji: any;
	emojiArray: any;
	isBetmodeSystem: boolean;
	systemBetTemplate: string;
}

const CouponTypes: FC<Props> = ({ title, isAkoBet, numOfSlipsInBetslip, renderEmoji, emojiArray, totalOdds, isBetmodeSystem, systemBetTemplate }) => {
	return (
		<div className="CouponTypes">
			{isAkoBet && !isBetmodeSystem && (
				<span className="CouponTypes__akoInfo">
					<p className="CouponTypes__couponDetail">{renderEmoji}</p>
					<p className="CouponTypes__couponDetail">{title}</p>
					<p className="CouponTypes__couponDetail">{numOfSlipsInBetslip}</p>
				</span>
			)}

			{!isAkoBet && !isBetmodeSystem && (
				<>
					<span className="CouponTypes__akoInfo">
						<span>{emojiArray[numOfSlipsInBetslip - 1]}</span>
						<span>{t('soloBetType')}</span>
					</span>
				</>
			)}

			{isBetmodeSystem && (
				<>
					<div className="CouponTypes__systemInfo">
						<img src={tools} alt="system" />
						<span>{t('systemBetType')}</span>
					</div>
					<span>{systemBetTemplate}</span>
				</>
			)}

			{!isBetmodeSystem && <span>{totalOdds.toFixed(2)}</span>}
		</div>
	);
};

export default CouponTypes;
